var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('a-card',{attrs:{"bordered":false}},[_c('holiday-select')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }